import { ObjectHelpers } from "../../helpers/object-helpers";

export class CreateLimitAlertModel {
    public symbol = '';
    public price = 0;
    public isLong = false;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}